import { Routes } from '@angular/router';
import { FavoriteItemsComponent } from './favorite-items/favorite-items.component';
import { ProfileFavoritesComponent } from './profile-favorites.component';

// pages
export const FavoritesRoutes: Routes = [
  {
    path: '',
    component: ProfileFavoritesComponent,
    data: { titleKey: 'routes.favorites' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'products',
      },
      {
        path: 'products',
        component: FavoriteItemsComponent,
        data: { titleKey: 'routes.favoritesProducts' },
      },
      {
        path: 'blogs',
        component: FavoriteItemsComponent,
        data: { titleKey: 'routes.favoritesBlogs' },
      },
      {
        path: 'posts',
        component: FavoriteItemsComponent,
        data: { titleKey: 'routes.favoritesPosts' },
      },
    ],
  },
];
